<form (change)=saveForm() [formGroup]="premieKind">
    <div *ngIf="betaaldePremiekind.length > 0">
        <div formArrayName="betaaldePremieKind">
            <div *ngFor="let item of betaaldePremiekind.controls; let k = index; "
                 [formGroupName]="k">
                <div class="row col-auto">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="k === 0 ? 'Omschrijving verzekering kind' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="omschrijvingKind"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="k === 0 ? 'Polisnummer' : ''"
                                                    class="custom-input-250"
                                                    formControlName="polisnummer"
                                                    id="polisnummerKind"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="k === 0 ? 'Bedrag' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedrag"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (click)="verwijderRijPremieKind(k)"
                                         [class]="k === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         class="delete"
                                         icon="trash"
                                         iconType="light"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="betaaldePremiekind.length === 0">
        <snelstart-ui-button (click)="addRijLoonPremieKind()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Premie verzekering meerderjarig invalide (klein)kind
        </snelstart-ui-button>
    </div>
    <div *ngIf="betaaldePremiekind.length > 0">
        <snelstart-ui-button (click)="addRijLoonPremieKind()" class="snelstart-ui-button pb-3" icon="plus"
                             type="link">Premie verzekering meerderjarig invalide (klein)kind toevoegen
        </snelstart-ui-button>
    </div>

</form>
